"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _Raven = _interopRequireDefault(require("Raven"));

var _react = _interopRequireWildcard(require("react"));

var _q = _interopRequireDefault(require("q"));

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var _debounce = _interopRequireDefault(require("transmute/debounce"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _immutable = require("immutable");

var _draftJs = require("draft-js");

var _draftConvert = require("draft-convert");

var _PlaybookRecord = _interopRequireDefault(require("playbooks-modal/records/PlaybookRecord"));

var _getQuestionAndAnswerFromEditorState = _interopRequireDefault(require("composer-plugins/utils/getQuestionAndAnswerFromEditorState"));

var _AutoSaveStatus = require("playbooks-modal/constants/AutoSaveStatus");

var _PublicationStages = _interopRequireDefault(require("playbooks-modal/constants/PublicationStages"));

var _configurePlugins = _interopRequireDefault(require("playbooks-modal/lib/configurePlugins"));

var _getEnabledPlaybookAssociations = _interopRequireDefault(require("playbooks-modal/lib/getEnabledPlaybookAssociations"));

var _EngagementTypes = require("customer-data-objects/engagement/EngagementTypes");

var _FloatingAlertStore = _interopRequireDefault(require("UIComponents/alert/FloatingAlertStore"));

var _PromiseHandlers = require("UIComponents/core/PromiseHandlers");

var _PropertiesApi = _interopRequireDefault(require("playbooks-modal/api/PropertiesApi"));

var SubmissionApi = _interopRequireWildcard(require("playbooks-modal/api/SubmissionApi"));

var PlaybookApi = _interopRequireWildcard(require("playbooks-modal/api/PlaybookApi"));

var _associationsAddedOrRemoved = _interopRequireDefault(require("playbooks-modal/utils/associationsAddedOrRemoved"));

var _SubmissionRecord = _interopRequireDefault(require("../records/SubmissionRecord"));

var _default = function _default(PlaybookComponent) {
  return _react.default.createClass({
    propTypes: {
      activityTypeOptions: _react.PropTypes.array,
      associationIds: _react.PropTypes.instanceOf(_immutable.Map),
      associations: _react.PropTypes.instanceOf(_immutable.Map),
      callDispositions: _react.PropTypes.instanceOf(_immutable.OrderedMap),
      content: _react.PropTypes.instanceOf(_draftJs.EditorState),
      getAuth: _react.PropTypes.func.isRequired,
      hasActivityTypes: _react.PropTypes.bool.isRequired,
      insertContent: _react.PropTypes.bool.isRequired,
      isPreview: _react.PropTypes.bool,
      onConfirm: _react.PropTypes.func.isRequired,
      onObjectPropertyChanged: _react.PropTypes.func,
      onReject: _react.PropTypes.func.isRequired,
      playbookId: _react.PropTypes.string,
      requestAssociations: _react.PropTypes.func,
      source: _react.PropTypes.string,
      sourceId: _react.PropTypes.string,
      sourceObject: _react.PropTypes.instanceOf(_immutable.Record),
      title: _react.PropTypes.string,
      questionsMap: _react.PropTypes.instanceOf(_immutable.Map),
      currencyCode: _react.PropTypes.string
    },
    getDefaultProps: function getDefaultProps() {
      return {
        activityTypeOptions: [],
        insertContent: false,
        fullPageModal: false,
        callDispositions: (0, _immutable.OrderedMap)(),
        associationIds: (0, _immutable.Map)(),
        associations: (0, _immutable.Map)(),
        sourceObject: null,
        questionsMap: (0, _immutable.Map)()
      };
    },
    getInitialState: function getInitialState() {
      this.isFirstSave = true;
      this.debouncedAutoSavePlaybookSubmission = (0, _debounce.default)(300, this.autoSavePlaybookSubmission);
      this.enabledAssociations = (0, _getEnabledPlaybookAssociations.default)(this.props.source);
      return {
        questions: (0, _immutable.Map)(),
        playbook: null,
        editorState: null,
        fetchError: false,
        properties: [],
        submissions: (0, _immutable.Map)(),
        propertiesFetching: true,
        engagementType: null,
        callDisposition: null,
        activityType: null,
        autoSaveStatus: _AutoSaveStatus.UNINITIALIZED,
        isSubmissionSaving: false,
        contentReady: false
      };
    },
    componentDidMount: function componentDidMount() {
      var _this = this;

      _q.default.Promise.all([// TODO: Only fetch used properties
      _PropertiesApi.default.fetchAllProperties(), this.loadPlaybook()]).then(function (_ref) {
        var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
            properties = _ref2[0],
            _ref2$ = _ref2[1],
            playbook = _ref2$.playbook,
            editorState = _ref2$.editorState,
            questions = _ref2$.questions,
            submissions = _ref2$.submissions,
            engagementType = _ref2$.engagementType,
            activityType = _ref2$.activityType;

        _this.updateDraftPlugins({
          questions: questions,
          properties: properties
        });

        _this.setState({
          playbook: playbook,
          editorState: editorState,
          questions: questions,
          submissions: submissions,
          engagementType: engagementType,
          activityType: activityType,
          properties: properties,
          propertiesFetching: false
        });
      }, function (error) {
        _Raven.default.captureException('LOAD_PLAYBOOK_ERROR', {
          extra: {
            response: error
          }
        });

        _this.setState({
          propertiesFetching: false,
          fetchError: true
        });

        (0, _PromiseHandlers.rethrowError)(error);
      });
    },
    componentDidUpdate: function componentDidUpdate(prevProps) {
      if (this.props.playbookId && this.props.playbookId !== prevProps.playbookId) {
        this.isFirstSave = true;
        this.setState({
          playbook: null,
          editorState: null,
          fetchError: false
        }, this.loadPlaybookAndUpdateState());
      }

      if ((0, _associationsAddedOrRemoved.default)(prevProps.associations, this.props.associations)) {
        this.updateDraftPlugins();
        this.forceUpdate();
      }
    },
    componentWillUnmount: function componentWillUnmount() {
      clearTimeout(this.setAutoSaveSuccess);
    },
    updateDraftPlugins: function updateDraftPlugins() {
      var _this2 = this;

      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$properties = _ref3.properties,
          properties = _ref3$properties === void 0 ? this.state.properties : _ref3$properties,
          _ref3$associations = _ref3.associations,
          associations = _ref3$associations === void 0 ? this.props.associations : _ref3$associations,
          _ref3$questions = _ref3.questions,
          questions = _ref3$questions === void 0 ? this.state.questions : _ref3$questions;

      var blockProps = {
        properties: properties,
        associations: associations,
        associationIds: this.props.associationIds,
        originId: this.props.playbookId,
        showPublishedQuestions: !this.props.isPreview,
        getAuth: this.props.getAuth,
        getCommentsOnly: function getCommentsOnly() {
          return false;
        },
        getInsertEmbedEnabled: _emptyFunction.default,
        getReadOnly: function getReadOnly() {
          return true;
        },
        getEditorState: function getEditorState() {
          return _this2.state.editorState;
        },
        getQuestionAndAnswerEnabled: function getQuestionAndAnswerEnabled() {
          return _this2.props.insertContent;
        },
        onInsertableLoaded: _emptyFunction.default,
        sourceObjectType: this.props.source,
        sourceObject: this.props.sourceObject,
        onObjectPropertyChanged: this.props.onObjectPropertyChanged,
        onSubmissionChanged: this.handleQuestionEntityChanged,
        enabledAssociations: this.enabledAssociations,
        questionsMap: questions
      };
      this.configuredPlugins = (0, _configurePlugins.default)({
        props: blockProps
      });
      this.toHTML = this.configuredPlugins(_draftConvert.convertToHTML);
    },
    shouldShowSaveButton: function shouldShowSaveButton() {
      var editorState = this.state.editorState;

      if (!editorState) {
        return false;
      }

      var contentState = (0, _getQuestionAndAnswerFromEditorState.default)(editorState);
      var hasQuestionAndAnswer = !contentState.getBlockMap().isEmpty();
      return this.props.insertContent && hasQuestionAndAnswer;
    },
    createEngagement: function createEngagement(submissionId) {
      var _this$state = this.state,
          editorState = _this$state.editorState,
          engagementType = _this$state.engagementType,
          callDisposition = _this$state.callDisposition,
          activityType = _this$state.activityType;
      var questionAndAnswers = (0, _getQuestionAndAnswerFromEditorState.default)(editorState);
      var html = this.toHTML(questionAndAnswers);
      this.props.onConfirm(html, {
        submissionId: submissionId,
        type: engagementType,
        selectedDisposition: callDisposition,
        selectedActivityType: activityType
      });
    },
    createPlaybookSubmission: function createPlaybookSubmission() {
      var _this$props = this.props,
          playbookId = _this$props.playbookId,
          source = _this$props.source,
          sourceId = _this$props.sourceId;
      return SubmissionApi.createSubmission({
        playbookId: playbookId,
        source: source,
        sourceId: sourceId,
        playbookSubmissionAnswers: this.state.submissions.valueSeq().toJS()
      });
    },
    updatePlaybookSubmission: function updatePlaybookSubmission() {
      return SubmissionApi.updateSubmission({
        playbookSubmissionId: this.state.submissions.first().submissionId,
        playbookSubmissionAnswers: this.state.submissions.valueSeq().toJS()
      });
    },
    autoSavePlaybookSubmission: function autoSavePlaybookSubmission() {
      var _this3 = this;

      var _this$props2 = this.props,
          isPreview = _this$props2.isPreview,
          insertContent = _this$props2.insertContent;

      if (isPreview || !insertContent) {
        return;
      }

      clearTimeout(this.setAutoSaveSuccess);
      this.setState({
        autoSaveStatus: _AutoSaveStatus.PENDING
      });
      var request = this.isFirstSave ? this.createPlaybookSubmission : this.updatePlaybookSubmission;
      request().then(function (submissions) {
        if (!submissions) {
          _this3.setState({
            autoSaveStatus: _AutoSaveStatus.UNINITIALIZED
          });

          return;
        }

        _this3.isFirstSave = false;

        _this3.setState({
          submissions: submissions
        }); // Show animation for at least 150ms


        _this3.setAutoSaveSuccess = setTimeout(function () {
          _this3.setState({
            autoSaveStatus: _AutoSaveStatus.SUCCEEDED
          });
        }, 150);
      }, function () {
        _this3.setState({
          autoSaveStatus: _AutoSaveStatus.FAILED
        });
      });
    },
    handleSaveContent: function handleSaveContent() {
      var _this4 = this;

      this.setState({
        isSubmissionSaving: true
      });
      return this.createPlaybookSubmission().then(function (savedSubmission) {
        _this4.createEngagement(savedSubmission.getIn(['playbookSubmission', 'id']));
      }, function (err) {
        _FloatingAlertStore.default.addAlert({
          type: 'danger',
          titleText: _react.default.createElement(_FormattedMessage.default, {
            message: "playbooksModal.error.submission.title"
          }),
          message: _react.default.createElement(_FormattedMessage.default, {
            message: "playbooksModal.error.submission.message"
          })
        });

        _this4.setState({
          isSubmissionSaving: false
        });

        (0, _PromiseHandlers.rethrowError)(err);
      });
    },
    handleEngagementTypeChange: function handleEngagementTypeChange(engagementType) {
      this.setState({
        engagementType: engagementType
      });
    },
    handleCallDispositionChange: function handleCallDispositionChange(callDisposition) {
      this.setState({
        callDisposition: callDisposition
      });
    },
    handleActivityTypeChange: function handleActivityTypeChange(activityType) {
      this.setState({
        activityType: activityType
      });
    },
    getAssociations: function getAssociations(questions) {
      var _this5 = this;

      if (!this.props.requestAssociations) {
        return;
      }

      var questionObjectTypes = questions.map(function (question) {
        return question.objectType;
      }).toSet();
      var associationTypesToFetch = questionObjectTypes.delete(this.props.source).filter(function (objectType) {
        return _this5.enabledAssociations.has(objectType);
      });
      var associationsMap = associationTypesToFetch.reduce(function (objectMap, objectType) {
        var firstAssociationId = _this5.props.associationIds.get(objectType, (0, _immutable.Set)()).first();

        if (!firstAssociationId) {
          return objectMap.set(objectType, (0, _immutable.Set)());
        }

        return objectMap.set(objectType, (0, _immutable.Set)([firstAssociationId]));
      }, (0, _immutable.Map)());
      this.props.requestAssociations(associationsMap);
    },
    handleQuestionEntityChanged: function handleQuestionEntityChanged(question) {
      var _this6 = this;

      this.setState(function (state) {
        return {
          submissions: state.submissions.update(question.questionId, function (submission) {
            return submission.merge({
              note: question.note,
              selectedAnswers: question.selected
            });
          })
        };
      }, function () {
        return _this6.debouncedAutoSavePlaybookSubmission();
      });
    },
    loadPlaybookAndUpdateState: function loadPlaybookAndUpdateState() {
      var _this7 = this;

      this.loadPlaybook().then(function (_ref4) {
        var playbook = _ref4.playbook,
            editorState = _ref4.editorState,
            questions = _ref4.questions,
            submissions = _ref4.submissions,
            engagementType = _ref4.engagementType,
            activityType = _ref4.activityType;

        _this7.updateDraftPlugins({
          questions: questions
        });

        _this7.setState({
          playbook: playbook,
          editorState: editorState,
          questions: questions,
          submissions: submissions,
          engagementType: engagementType,
          activityType: activityType
        });
      });
    },
    loadPlaybook: function loadPlaybook() {
      return this.props.isPreview ? this.loadComposition() : this.loadPublication();
    },
    loadComposition: function loadComposition() {
      var _this$props3 = this.props,
          title = _this$props3.title,
          content = _this$props3.content,
          questionsMap = _this$props3.questionsMap;
      var _this$state2 = this.state,
          submissions = _this$state2.submissions,
          engagementType = _this$state2.engagementType,
          activityType = _this$state2.activityType;
      return _q.default.Promise.resolve({
        playbook: new _PlaybookRecord.default({
          title: title
        }),
        editorState: _draftJs.EditorState.createWithContent(content.getCurrentContent()),
        questions: questionsMap,
        // These shouldn't be changing for a composition but we should return the same results as loadPublication here
        submissions: submissions,
        engagementType: engagementType,
        activityType: activityType
      });
    },
    loadPublication: function loadPublication() {
      var _this$props4 = this.props,
          playbookId = _this$props4.playbookId,
          source = _this$props4.source,
          sourceId = _this$props4.sourceId;
      return PlaybookApi.fetch({
        playbookId: playbookId,
        source: source,
        sourceId: sourceId,
        isPublished: true
      }).then(this.handlePlaybookFetchSuccess, this.handlePlaybookFetchFailure);
    },
    handlePlaybookFetchSuccess: function handlePlaybookFetchSuccess(_ref5) {
      var playbook = _ref5.playbook,
          questions = _ref5.questions;
      var currencyCode = this.props.currencyCode;
      this.getAssociations(questions);
      var content = null;
      var editorState = null;
      var isPlaybookPublished = playbook.publicationStage === _PublicationStages.default.PUBLISHED || playbook.publicationStage === _PublicationStages.default.PUBLISHED_WITH_EDITS;

      if (isPlaybookPublished) {
        content = (0, _draftJs.convertFromRaw)(JSON.parse(playbook.body));
        editorState = _draftJs.EditorState.createWithContent(content);
      }

      return {
        playbook: playbook,
        questions: questions.map(function (question) {
          return question.set('currencyCode', currencyCode);
        }),
        submissions: questions.map(_SubmissionRecord.default.fromQuestionEntityRecord),
        editorState: editorState,
        engagementType: playbook.submissionPreferences ? playbook.submissionPreferences.engagementType : _EngagementTypes.CALL,
        activityType: playbook.submissionPreferences && playbook.submissionPreferences.activityTypes.length !== 0 ? playbook.submissionPreferences.activityTypes[0].name : null
      };
    },
    handlePlaybookFetchFailure: function handlePlaybookFetchFailure(error) {
      this.setState({
        fetchError: true
      });
      (0, _PromiseHandlers.rethrowError)(error);
    },
    render: function render() {
      var _this$props5 = this.props,
          onReject = _this$props5.onReject,
          callDispositions = _this$props5.callDispositions,
          activityTypeOptions = _this$props5.activityTypeOptions,
          hasActivityTypes = _this$props5.hasActivityTypes;
      var _this$state3 = this.state,
          playbook = _this$state3.playbook,
          editorState = _this$state3.editorState,
          fetchError = _this$state3.fetchError,
          propertiesFetching = _this$state3.propertiesFetching,
          isSubmissionSaving = _this$state3.isSubmissionSaving,
          autoSaveStatus = _this$state3.autoSaveStatus;
      return _react.default.createElement(PlaybookComponent, {
        activityType: this.state.activityType,
        activityTypeOptions: activityTypeOptions,
        callDisposition: this.state.callDisposition,
        callDispositions: callDispositions,
        configuredPlugins: this.configuredPlugins,
        editorState: editorState,
        engagementType: this.state.engagementType,
        fetchError: fetchError,
        hasActivityTypes: hasActivityTypes,
        isSubmissionSaving: isSubmissionSaving,
        autoSaveStatus: autoSaveStatus,
        onActivityTypeChange: this.handleActivityTypeChange,
        onCallDispositionChange: this.handleCallDispositionChange,
        onReject: onReject,
        onEngagementTypeChange: this.handleEngagementTypeChange,
        onSave: this.handleSaveContent,
        playbook: playbook,
        propertiesFetching: propertiesFetching,
        showSaveButton: this.shouldShowSaveButton()
      });
    }
  });
};

exports.default = _default;
module.exports = exports.default;